export default class NavigateTo {
  constructor(context) {
    this.context = context;
  }

  run(location) {
    this.context.router.navigateTo(location);
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/current_location/navigate_to.js